

import React from 'react';
import ZNetwork from "./znetwork";
import {APP} from "./App";
import { AUTH } from './AMCAuth';
import {ROUTER} from "./AMCRouter";
import PleaseStandBy from "./PleaseStandBy";
import ZooErrorFoundPage from "./ZooErrorFoundPage";

export default class AMCUserConfirmEmail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		ZNetwork.get("confirm", this.props.code, (err, payload) => {
			if (err) {
				this.setState({ error: "Invalid link or link expired" });
			} else {
				AUTH.signedIn( payload.user, payload.settings, payload.group );
				APP.setBanner("Awesome. Thanks for that");
				ROUTER.pushRoute("/" + payload.user.uri);
			}
		});
	}
	render() {
		let { error, found } = this.state;
		if (error) {
			return <ZooErrorFoundPage />;
		}
		if (!found) {
			return <PleaseStandBy />;
		}
		return	(
			<div className="AMCSignUpPage">
				Email confirmed
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/AMCUserConfirmEmail.js